import React, { Component } from 'react';
import { Button, Col, Form, InputNumber, notification, Row, Spin } from 'antd';

import * as globalConfigController from '../../../../../../services/api/config';
import './ConfigForm.scss';

const FormItem = Form.Item;

export class ConfigForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        }
    }

    getConfig() {
        const { form } = this.props;
        this.setState({ isLoading: true });

        globalConfigController.getConfigs()
            .then((res) => res.json())
            .then((json) => {
                form.setFieldsValue(json.config)

                this.setState({ isLoading: false });
            })
    }

    handleSubmit(e) {
        const { form } = this.props;

        e.preventDefault();
        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                globalConfigController.updateConfigs(values)
                    .then((res) => res.json())
                    .then((json) => {
                        this.setState({ isLoading: false });
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isLoading: false });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    componentDidMount() {
        this.getConfig();
    }

    render() {
        const { form } = this.props;
        const { isLoading } = this.state;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };

        return (
            <Spin spinning={isLoading}>
                <Form className="ConfigForm" onSubmit={(e) => this.handleSubmit(e)}>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Lead Expiry Day">
                                {
                                    getFieldDecorator('leadExpiryDay', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                    })(
                                        <InputNumber 
                                            style={{ width: 150 }}
                                            placeholder="Number of Days"
                                            min={0}
                                            formatter={value => value ? `${value} Days` : ''} 
                                            parser={string => string.replace(/[^\d]/g, '')}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <FormItem>
                            <Button type="primary" htmlType="submit">Update</Button>
                        </FormItem>
                    </Row>
                </Form>
            </Spin>
        );
    }
}

const WrappedConfigForm = Form.create()(ConfigForm);
export default WrappedConfigForm;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ConfigPage/components/ConfigForm/ConfigForm.js